import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { CinematicShowcase } from './components/showcase/CinematicShowcase';
import { Features } from './components/Features';
import { Programs } from './components/Programs';
import { Community } from './components/Community';
import { CtaBanner } from './components/CtaBanner';
import { Footer } from './components/Footer';
import { ScrollProgressBar } from './components/motion/ScrollProgressBar';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="31bi7xhgaoacs">
      <div className="min-h-screen w-full bg-navy-deep font-sans text-white" data-id="element-1" data-mp="31ctd9lpe1q60">
        <ScrollProgressBar data-id="element-2" data-mp="2wiffxdr618yp" />
        <Navbar data-id="element-3" data-mp="2wi5nljineppu" />
        <main data-id="element-4" data-mp="28u5x8kp911bs">
          <Hero data-id="element-5" data-mp="28tw972nrl48q" />
          <StatsBar data-id="element-6" data-mp="28te4dhn1dhp7" />
          <CinematicShowcase data-id="element-7" data-mp="28sl3gxardmez" />
          <Features data-id="element-8" data-mp="23vck4tdvjcc5" />
          <Programs data-id="element-9" data-mp="23vuoyeelqyvo" />
          <Community data-id="element-10" data-mp="23u9qidp62vsj" />
          <CtaBanner data-id="element-11" data-mp="23v2rsz5cwt3a" />
        </main>
        <Footer data-id="element-12" data-mp="3ik7gihlkcdr6" />
      </div>
    </LanguageProvider>;
}